import React, { useEffect, useState } from "react";
import Select from 'react-select';

import PanelTemplate from "../../templates/Panel";
import Table from "../../components/Table";
import Box from "../../components/Box";
import Modal from "../../components/Modal";
import Button from "../../components/Button";
import PageHeader from "../../components/PageHeader";
import FilterSimple from "../../components/FilterSimple";
import DotStatus from "../../components/DotStatus";
import { useNavigate } from "react-router-dom";
import api from "../../services/api";
import { renderError } from "../../helpers/errors";
import moment from "moment";
import { createOptions } from "../../helpers/selects";
import { hasPermission } from "../../services/auth";
import { ModalDelete } from "../../components/ModalDelete";
import Pagination from "../../components/Pagination";
import { ModalFilter } from "../Product/ModalFilter";

import SortHeader from "../../components/SortHeader";
import { convertIntToMoney } from "../../helpers/conversions";
import FilterAndPaginate from "../../components/FilterAndPaginate";

import ButtonDropdown from "../../components/ButtonDropdown";
import ModalUpdatePricesBulk from "../../components/ModalUpdatePricesBulk";
import ModalUpdateStockBulk from "../../components/ModalUpdateStockBulk";


const customStyles = {
    control: (provided, state) => ({
      ...provided,
      minHeight: '35px',
      height: '35px',
      borderTopLeftRadius: 0,
      borderBottomLeftRadius: 0,
      borderTopRightRadius: '3px',
      borderBottomRightRadius: '3px',
      boxShadow: state.isFocused ? null : null,
      fontSize: '14px',
      width: 250
    }),
}

const indexMap = [
    { index: 'Nome', value: 'name' },
    // ...(hasPermission('show_product_supplier_price_in_budget')
    //     ? [{ index: 'Preço a partir de', value: 'price' }]
    //     : []),
    { index: 'Preço a partir de', value: 'price' },
    { index: 'Estoque total', value: 'stock' },
    { index: 'SKU', value: 'sku' },
    { index: 'Última atualização', value: 'updated_at' },
    { index: 'Cadastrado em', value: 'created_at' },
    { index: 'Status', value: 'status' },
];

export const ProductList = () => {
    const [loading, setLoading] = useState(false);
    const [filters, setFilters] = useState('');
    const [data, setData] = useState({header: [], rows: []});
    const [products, setProducts] = useState([]);

    const [categories, setCategories] = useState([]);
    const [selectedCategory, setSelectedCategory] = useState(null);

    const [currentPage, setCurrentPage] = useState(1);
    const [lastPage, setLastPage] = useState(1);
    const [perPage, setPerPage] = useState(20);
    const [totalResults, setTotalResults] = useState(0);
    const [hasNextPage, setHasNextPage] = useState(false);
    const [hasPrevPage, setHasPrevPage] = useState(false);

    const [selectedIds, setSelectedIds] = useState([]);
    const [showConfirmMultipleDelete, setShowConfirmMultipleDelete] = useState(false);

    const [showFilter, setShowFilter] = useState(false);
    const [customFilters, setCustomFilters] = useState('');

    const [orientation, setOrientation] = useState('desc');
    const [ordenationItem, setOrdenationItem] = useState('created_at');
    const [shouldFetch, setShouldFetch] = useState(false);

    const [showUpdatePricesModal, setShowUpdatePricesModal] = useState(false);
    const [showUpdateStocksModal, setShowUpdateStocksModal] = useState(false);

    const navigate = useNavigate();

    const handleOrdenation = (orientationItem, oredenation) => {
        setOrientation(oredenation);
        setOrdenationItem(orientationItem);
    };

    const handleSetCustomFilters = value => {
        setCustomFilters(value);
        setCurrentPage(1);
    }

    useEffect(() => {
        getCategories();
    }, []);


    useEffect(() => {
        if (currentPage !== 1) {
            setCurrentPage(1);
        } else {
            setShouldFetch(true);
        }
    }, [filters, selectedCategory, orientation, ordenationItem]);

    useEffect(() => {
        getProducts();
    }, [currentPage]);

    useEffect(() => {
        if (shouldFetch) {
            getProducts();
            setShouldFetch(false);
        }
    }, [shouldFetch]);

    useEffect(() => {
        setFilters(customFilters);
    }, [customFilters])

    useEffect(() => {
        generateData();
    }, [products]);

    const getProducts = () => {
        setProducts([]);
        setLoading(true);
        let sortedItens = `&ordenation_item=${ordenationItem}&orientation=${orientation}`;
        let categoryFilter = selectedCategory === null ? '' : `&filters[0][related][categories.id][equal]=${selectedCategory}`;
        api.get(`/product/paginate?${filters}${categoryFilter}${sortedItens}&page=${currentPage}`).then(res => {
            setProducts(res.data.resources.data);
            setCurrentPage(res.data.resources.pagination.current_page);
            setLastPage(res.data.resources.pagination.last_page)
            setPerPage(res.data.resources.pagination.per_page)
            setTotalResults(res.data.resources.pagination.total)
            setHasNextPage(res.data.resources.pagination.next_page_url !== null);
            setHasPrevPage(res.data.resources.pagination.prev_page_url !== null);
        }).catch(error => {
            renderError(error);
        }).then(() => setLoading(false));
    }

    const getCategories = () => {
        api.get(`/category`).then(res => {
            let toCategories = [];
            res.data.resources.map(category => {
                toCategories.push(category);
                category.categories.map(subcategory => toCategories.push({
                    ...subcategory,
                    name: `${category.name} > ${subcategory.name}`
                }));
            });
            setCategories(toCategories);
        });
    }

    const generateData = () => {
        
        const header = [
        'SKU',
        'Imagem',
        'Nome',
       /* ...(hasPermission('show_product_supplier_price_in_budget')
            ? ['Preço a partir de']
            : []),*/
        'Estoque total',
        'Última atualização',
        'Cadastrado em',
        'Status',
        ];

        const rows = [];

        products.map(product => {
            let image =  <img src={ require(`../../assets/images/svgs/default.svg`).default } />;
            if(product.image){
                image = <img src={product.image.image_url.small} />;
            }

            rows.push({
                data: [
                    product.sku,
                    image,
                    product.name,
                   /* ...(hasPermission('show_product_supplier_price_in_budget')
                    ? [product?.price ? convertIntToMoney(product.price, true) : 'R$ 0,00']
                    : []), */
                    (product?.stock ?? 0).toLocaleString('pt-BR'),
                    moment(product.updated_at).format('DD/MM/YYYY HH:mm'),
                    moment(product.created_at).format('DD/MM/YYYY HH:mm'),
                    product.status ? 'Ativo' : 'Inativo',
                ],
                to: `/product/edit/${product.id}`,
                id: product.id
            })
        });

        setData({header, rows});
    }

    const deleteMultipleProducts = () => {
        setLoading(true);

        api.delete(`/product/multiple`, {
            data: {
                ids: selectedIds
            }
        }).then(res => {
            setSelectedIds([]);
            getProducts();
            setShowConfirmMultipleDelete(false);
        }).catch(error => {
            renderError(error);
            setLoading(false);
        });
    }

    const handleSetFilter = value => {
        setCurrentPage(1);
        setFilters(value);
    }

    return (
        <>
            <ModalDelete
                show={showConfirmMultipleDelete}
                text={<p>Tem certeza que deseja apagar <strong>{selectedIds.length} {selectedIds.length > 1 ? 'produtos' : 'produto'}</strong>?</p>}
                action={deleteMultipleProducts}
                loading={loading}
                close={() => setShowConfirmMultipleDelete(false)}
            />
            <ModalUpdatePricesBulk
                show={showUpdatePricesModal}
                close={() => setShowUpdatePricesModal(false)}
                refresh={getProducts}
            />
            <ModalUpdateStockBulk
                show={showUpdateStocksModal}
                close={() => setShowUpdateStocksModal(false)}
                refresh={getProducts}
            />
            <PanelTemplate id="product-list">
                {/* <ModalFilter
                    setCurrentPage={setCurrentPage}
                    showFilter={showFilter}
                    setShowFilter={setShowFilter}
                    customFilters={customFilters}
                    setCustomFilters={handleSetCustomFilters}
                /> */}
                <PageHeader
                    left={
                        <>
                            <FilterAndPaginate
                                params={[
                                    {name: 'Nome', key: '[name]', type: 'text' },
                                    {name: 'SKU', key: '[sku]', type: 'text' },
                                ]}
                                filter={handleSetFilter}
                            />
                      {/*   <Select
                                placeholder="Escolha uma categoria..."
                                options={[{label: 'Todas as categorias', value: null},{label: 'Sem categoria', value: 'without_categories'}, ...createOptions(categories, 'name', 'id')]}
                                onChange={e => setSelectedCategory(e.value)}
                                value={
                                    selectedCategory === 'without_categories'
                                        ? { label: 'Sem categoria', value: 'without_categories' }
                                        : selectedCategory === null
                                        ? { label: 'Todas as categorias', value: null }
                                        : {
                                            label: categories.find(c => c.id === selectedCategory)?.name,
                                            value: selectedCategory
                                        }
                                }
                                styles={customStyles}
                            /> */}
                        </>
                    }

                    right={
                        <>
                            {selectedIds.length > 0 &&
                                <Button 
                                type={`secondary`} 
                                size={`small`} 
                                svg={`delete`}
                                text={`Excluir ${selectedIds.length} selecionados`} 
                                action={() => setShowConfirmMultipleDelete(true)}  
                                />
                            }
                            {/* <Button type={`secondary`} size={`small`} text={`Filtrar`} svg="filter" action={() => setShowFilter(true)} /> */}
                           
                            {/* <Button type={`secondary`} size={`small`} text={`Filtrar`} svg="filter"  /> */}
                            
                            <ButtonDropdown
                                type="primary"
                                text="Ações em massa"
                                svg="zap"
                                actions={[
                                    {
                                        text: 'Atualizar preços em massa',
                                        svg: 'money',
                                        action: () => setShowUpdatePricesModal(true)
                                    },
                                    {
                                        text: 'Atualizar estoques em massa',
                                        svg: 'items',
                                        action: () => setShowUpdateStocksModal(true)
                                    }
                                ]}
                                size="small"
                            />
                        
                            <Button type={`primary`} size={`small`} text={`Cadastrar produto`} svg="plus-white" link={`/product/create`}  />
                            
                        </>
                    }
                />
                
                <Box className={`no-padding with-pagination`}>
                    <Table 
                        header={data.header} 
                        rows={data.rows} 
                        loading={loading}
                        checks={true} 
                        selectedIds={selectedIds}
                        setSelectedIds={setSelectedIds}
                        sortOrdenationAction={(index) => (
                            <SortHeader
                                index={index}
                                ordenationItem={ordenationItem}
                                orientation={orientation}
                                onSort={handleOrdenation}
                                indexMap={indexMap}
                            />
                        )}
                    />
                </Box>
                {!loading &&
                    <Pagination
                        currentPage={currentPage}
                        lastPage={lastPage}
                        perPage={perPage}
                        totalResults={totalResults}
                        hasNextPage={hasNextPage}
                        hasPrevPage={hasPrevPage}
                        setCurrentPage={setCurrentPage}
                    />
                }
            </PanelTemplate>
        </>
    );
}

export default ProductList;